import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const CategoryService = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/menucategory`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/menucategory/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/menucategory/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/${slug}/menucategory/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default CategoryService;
